
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/setup",
      function () {
        return require("private-next-pages/docs/antara/setup/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/setup"])
      });
    }
  